var map = {
	"./de/group-logo.png": "ZGrP",
	"./en/group-logo.png": "95ge",
	"./es/group-logo.png": "WVqQ",
	"./fr/group-logo.png": "zLdX",
	"./ja/group-logo.png": "7jT6",
	"./ko/group-logo.png": "4PhN",
	"./pt/group-logo.png": "fYyT",
	"./ru/group-logo.png": "lUax",
	"./tc/group-logo.png": "WVi3",
	"./th/group-logo.png": "xHHM"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "m+38";